module.exports = __webpack_public_path__ + "img/swipe2.54ac6151.png";